module.exports = __webpack_public_path__ + "img/gold20.cec6bec7.png";